import { useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import MultiCarousel from 'react-multi-carousel';
import CkeditorRenderer from '../ckeditor-renderer/ckeditor-renderer';
import YoutubeContainer from '../youtube-container/youtube-container';
import styles from './testimonials-carousel.module.scss';

export default function TestimonialsCarousel({ testimonials, style: parentStyle, isDesktop }) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const totalCount = testimonials.length;

  const renderForMobile = () => {
    return (
      <ScrollContainer vertical={false} style={{ display: 'flex', overflowX: 'scroll' }}>
        {testimonials.map((el, i) => renderForDesktop(i))}
      </ScrollContainer>
    );
  };

  const renderForDesktop = (i) => {
    return testimonials[i]?.video_quote ? (
      <div className={styles.description} key={i}>
        <div className={styles.media}>
          <YoutubeContainer fullWidth embedCode={testimonials[i]?.video_quote}></YoutubeContainer>
        </div>

        <div className={styles.text}>
          <CkeditorRenderer html={testimonials[i]?.quote}></CkeditorRenderer>

          {testimonials[i]?.author && <p className={styles.author}>{testimonials[i]?.author}</p>}
        </div>
      </div>
    ) : (
      <div className={styles.description} key={i}>
        <div className={styles.text}>
          <CkeditorRenderer html={testimonials[i]?.quote}></CkeditorRenderer>

          {testimonials[i]?.author && <p className={styles.author}>{testimonials[i]?.author}</p>}
        </div>
      </div>
    );
  };

  return (
    <div id="testimonials" className={styles.carousel} style={{ ...parentStyle }}>
      <div className={styles.feature}>
        <p className={styles.title}>Testimonials</p>

        {isDesktop ? renderForDesktop(currentIdx) : renderForMobile()}
      </div>

      {isDesktop && (
        <div className={styles.pagination}>
          <div className={styles.index}>
            {currentIdx + 1} of {totalCount}
          </div>
          {isDesktop && (
            <div className={styles.nav}>
              {currentIdx > 0 && (
                <span className={styles.action} onClick={setCurrentIdx.bind(this, currentIdx - 1)}>
                  Prev
                </span>
              )}
              {currentIdx < totalCount - 1 && (
                <span className={styles.action} onClick={setCurrentIdx.bind(this, currentIdx + 1)}>
                  Next
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
